import React, { useEffect } from 'react';
// import jsonData from './../testdata.json';
import trustImage from './../assets/images/sider.png';
import checkIcon from './../assets/images/check-icon.svg';
import phoneIcon from './../assets/images/phone-icon.svg';
import godaddyImage from './../assets/images/globle.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarDays } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import { useLocation } from "react-router-dom";







function LeftMenu(props) {
    const location = useLocation();
    const userData = useSelector((state) => state.user.user);
    const referenceCode = localStorage.getItem('loginData');
    const refData = JSON.parse(referenceCode);
    useEffect(() => {
        // Scroll to top on mount
        window.scrollTo(0, 0);
    }, []);
    return (<>
        <div className="right-area-main">
            <div className='user-info-main'>
                <h2>Your Information</h2>
                <div className='date'>
                    <div className='icon'><FontAwesomeIcon icon={faCalendarDays} /></div>
                    <div className='content'>
                        <p>Cover Date:</p>
                        <h5>{userData?.HomeDetails?.RenewalDate}</h5>
                    </div>
                </div>
                <p>Policy Reference: <span>{refData.referenceCode}</span></p>
                <p>Name: <span>{
                    userData?.ProposerDetails?.[1] ? <>
                        {userData?.ProposerDetails?.[0]?.["Proposer.Person.Title"]} {' '}
                        {userData?.ProposerDetails?.[0]?.["Proposer.Person.Forenames"]} {' '}
                        {userData?.ProposerDetails?.[0]?.["Proposer.Person.Surname"]}</>
                        :
                        <>
                            {userData?.ProposerDetails?.["Proposer.Person.Title"]} {' '}
                            {userData?.ProposerDetails?.["Proposer.Person.Forenames"]} {' '}
                            {userData?.ProposerDetails?.["Proposer.Person.Surname"]}</>
                }
                </span>
                </p>
                <p className='d-block'>Address: <span className='d-block'>
                    {userData?.HomeDetails?.["Home.Address.AddrLine1"]} {' '}
                    {userData?.HomeDetails?.["Home.Address.AddrLine2"]} {' '}
                    {userData?.HomeDetails?.["Home.Address.AddrLine3"]} {' '}
                    {userData?.HomeDetails?.["Home.Address.AddrLine4"]} {' '}
                    {userData?.HomeDetails?.["Home.Address.AddrPostCode"]}
                </span>
                </p>
                <p>House Type: <span>{userData?.HomeDetails?.["Home.HouseType"]}</span></p>
                {/* <p>Policy Smokers: <span>{userData?.HomeDetails?.["Policy.Smokers"]}</span></p> */}
                <p>Insurer: {props.productBothPrices ? props.selectInsurerType.type === 'alternativeInsurer' ? <span>{userData?.PaymentDetails?.AlternativeInsurer}</span> :
                    <span>{userData?.HomeDetails?.Insurer}</span>
                    : userData?.PaymentDetails?.AlternativePolicyWording && userData?.PaymentDetails?.AlternativeInsurer ? <span>{userData?.PaymentDetails?.AlternativeInsurer}</span> : <span>{userData?.HomeDetails?.Insurer}</span>}</p>

                {props.productBothPrices ? <>
                    {props.selectInsurerType.type === 'alternativeInsurer' ? <p className='justify-content-end'><a href={userData?.PaymentDetails?.AlternativePolicyWording} rel="noreferrer" target='_blank' className='text-white'>View Insurer Policy Wording</a></p>
                        : <p className='justify-content-end'><a href={userData?.HomeDetails?.PolicyWording} rel="noreferrer" target='_blank' className='text-white'>View Insurer Policy Wording</a></p>}</>
                    : <>
                        {userData?.PaymentDetails?.AlternativePolicyWording && userData?.PaymentDetails?.AlternativeInsurer ? <p className='justify-content-end'><a href={userData?.PaymentDetails?.AlternativePolicyWording} rel="noreferrer" target='_blank' className='text-white'>View Insurer Policy Wording</a></p>
                            : <p className='justify-content-end'><a href={userData?.HomeDetails?.PolicyWording} rel="noreferrer" target='_blank' className='text-white'>View Insurer Policy Wording</a></p>}
                    </>}
                <p>Cover: <span className='text-end'>{userData?.HomeDetails?.["Policy.Cover"]}</span></p>
                {userData?.HomeDetails?.["Policy.Cover"] === 'Buildings' ?
                    <>
                        <p className='align-items-start'>
                            <b>
                                Buildings <br /> Excess
                            </b>
                            <div>
                                <b>£{Number(userData?.HomeDetails?.["Home.Buildings.BVExcess"]) + Number(userData?.HomeDetails?.["Home.Buildings.BCExcess"])}</b><br />
                                <span>£{userData?.HomeDetails?.["Home.Buildings.BVExcess"]} - Voluntary</span><br />
                                <span>£{userData?.HomeDetails?.["Home.Buildings.BCExcess"]} - Compulsory</span>
                            </div>
                        </p>
                    </>
                    : null}
                {userData?.HomeDetails?.["Policy.Cover"] === 'Contents' ?
                    <>
                        <p className='align-items-start'>
                            <b>
                                Contents<br /> Excess
                            </b>
                            <div>
                                <b>£{Number(userData?.HomeDetails?.["Home.Contents.CVExcess"]) + Number(userData?.HomeDetails?.["Home.Contents.CCExcess"])}</b><br />
                                <span>£{userData?.HomeDetails?.["Home.Contents.CVExcess"]} - Voluntary</span><br />
                                <span>£{userData?.HomeDetails?.["Home.Contents.CCExcess"]} - Compulsory</span><br />
                            </div>
                        </p>
                    </>
                    : null}

                {userData?.HomeDetails?.["Policy.Cover"] === 'Buildings & Contents' ?
                    <>
                        <p className='align-items-start'>
                            <b>
                                Buildings <br /> Excess
                            </b>
                            <div>
                                <b>£{Number(userData?.HomeDetails?.["Home.Buildings.BVExcess"]) + Number(userData?.HomeDetails?.["Home.Buildings.BCExcess"])}</b><br />
                                <span>£{userData?.HomeDetails?.["Home.Buildings.BVExcess"]} - Voluntary</span><br />
                                <span>£{userData?.HomeDetails?.["Home.Buildings.BCExcess"]} - Compulsory</span>
                            </div>
                        </p>
                        <p className='align-items-start'>
                            <b>
                                Contents<br /> Excess
                            </b>
                            <div>
                                <b>£{Number(userData?.HomeDetails?.["Home.Contents.CVExcess"]) + Number(userData?.HomeDetails?.["Home.Contents.CCExcess"])}</b><br />
                                <span>£{userData?.HomeDetails?.["Home.Contents.CVExcess"]} - Voluntary</span><br />
                                <span>£{userData?.HomeDetails?.["Home.Contents.CCExcess"]} - Compulsory</span><br />
                            </div>
                        </p>
                    </>
                    : null}
            </div>

            <div className='securing-area-main'>
                <h2>Securing Your Peace of Mind</h2>
                <div className="content">
                    <p>
                        Remember, choosing Thamesbank means opting for unparalleled excellence in UK insurance since 1989, with our commitment to fast, personalised service and a team that prioritises your peace of mind.
                    </p>
                    <ul>
                        <li><img src={checkIcon} alt="Trust" /> <span>Instant Reach – 3 ring pickup</span></li>
                        <li><img src={checkIcon} alt="Trust" /> <span>Real Talk – Directly to a human, everytime</span></li>
                        <li><img src={checkIcon} alt="Trust" /> <span>Support staff average 10+ years' industry experience</span></li>
                        <li><img src={checkIcon} alt="Trust" /> <span>UK Based Contact Center</span></li>
                    </ul>
                </div>
            </div>

            <div className='securing-area-main trustpilot-main securing-area-main-img'>
                {/* <h2 style={{ fontSize: '14px', marginBottom: '15px' }}>What Our Customer are Saying...</h2> */}
                <div className="text-center">
                    <img src={trustImage} alt="Trustpilot" className="img-fluid w-80" />
                </div>
            </div>

            <div className='policies-area-main'>
                <h2>Most Of Our Policies Include</h2>
                <div className='content'>
                    <ul>
                        <li><img src={checkIcon} alt="Trust" /> <span>Alternative Accommodation</span></li>
                        <li><img src={checkIcon} alt="Trust" /> <span>New for Old Cover</span></li>
                        <li><img src={checkIcon} alt="Trust" /> <span>Underground Services Pipes and Cables</span></li>
                        <li><img src={checkIcon} alt="Trust" /> <span>Emergency Helplines</span></li>
                    </ul>
                </div>
            </div>

            <div className='policies-area-main'>
                <h2>Your Security</h2>
                <div className='content'>
                    <p>Your information is protected by a 256-bit SSL connection provided by our technology partner GoDaddy, and processed in line with UK Data Protection laws.</p>
                    <p>Read our <a href="https://thamesbankinsurance.co.uk/wp-content/uploads/2024/12/Privacy-Notice-v6-June-2024.pdf" target="_blank" rel="noreferrer" >Privacy Notice</a> to learn how we handle and safeguard your data.</p>
                    <img src={godaddyImage} alt="Trust" className='w-100' />
                </div>
            </div>

            <div className='contact-area-main'>
                <h2>Contact Us</h2>
                <div className='phone-box'>
                    <img src={phoneIcon} alt='Icon' />
                    <div>
                        <p>Telephone:</p>
                        <h3>0203 3029263</h3>
                    </div>
                </div>
                <p className='mb-0'><b>Email:</b></p>
                <p>sales@thamesbankinsurance.co.uk</p>
                <div className='office-hour-box'>
                    <h5>Office Hours:</h5>
                    <p><b>Mon to Thur</b></p>
                    <p>9.00 am to 6.30 pm</p>
                    <p>Fri 9.00 am to 5.30 pm</p>
                </div>
                <p className='contact-end'>Thamesbank Insurance Services<br />is a trading name of Paragon Car Limited and are authorised and regulated by the Financial Conduct Authority, FCA no: 312028
                </p>
            </div>
        </div>
    </>);
}




export default LeftMenu;